export const parcelReport = {
  id: 'PARCEL_REPORT',
  identifier: 'opp_id',
  sections: [
    {
      title: 'Deal Report',
      titleSelector: 'parcels[0].address',
      properties: [
        {
          column: 'opp_name',
          type: 'HIDDEN',
        },
        {
          column: 'geom',
          padding: 20,
          type: 'MAP',
          options: ['STREETVIEW'],
        },
        {
          type: 'ACTIONS',
          options: ['DIRECTIONS'],
        },
        {
          label: 'Property Details',
          type: 'TITLE',
        },
        {
          column: 'address',
          default: 'N/A',
          type: 'TEXT',
          label: 'Address',
        },
        {
          column: 'city_name',
          default: 'N/A',
          type: 'TEXT',
          label: 'City',
        },
        {
          column: 'county_name',
          default: 'N/A',
          type: 'TEXT',
          label: 'County',
        },
        {
          column: 'prosperity_region',
          default: 'N/A',
          type: 'TEXT',
          label: 'Prosperity Region',
        },
        {
          column: 'six_city',
          default: 'N/A',
          type: 'TEXT_MAP',
          label: 'In the 6 Cities',
          map: {
            1: 'Yes',
            0: 'No',
          },
        },
        {
          label: 'Deal Details',
          type: 'TITLE',
        },
        {
          column: 'opp_id',
          default: 'N/A',
          type: 'TEXT',
          label: 'Deal ID',
        },
        {
          column: 'opp_totalprivateinvestment',
          default: 'N/A',
          type: 'DOLLARS',
          label: 'Total Private Investment Amount',
        },
        {
          column: 'opp_totalincentiveamount',
          default: 'N/A',
          type: 'DOLLARS',
          label: 'Total MEDC Investment Amount',
        },
        {
          column: 'opp_totalprojectamount',
          default: 'N/A',
          type: 'DOLLARS',
          label: 'Total Investment Amount',
        },
        {
          column: 'leverage_ratio',
          default: 'N/A',
          type: 'DOLLARS',
          label: 'MEDC Private Investment Leverage Ratio',
        },
        {
          column: 'has_grant',
          default: 'N/A',
          type: 'TEXT_MAP',
          label: 'Has Grant',
          map: {
            1: 'Yes',
            0: 'No',
          },
        },
        {
          column: 'has_loan',
          default: 'N/A',
          type: 'TEXT_MAP',
          label: 'Has Loan',
          map: {
            1: 'Yes',
            0: 'No',
          },
        },
        {
          column: 'opp_type_combo',
          default: 'N/A',
          type: 'TEXT',
          label: 'Deal Type',
        },
        {
          column: 'program_name',
          default: 'N/A',
          type: 'TEXT',
          label: 'Program Name',
        },
        {
          column: 'cluster',
          default: 'N/A',
          type: 'TEXT_MAP',
          label: 'Submarket',
          map: {
            3: 'Weak Market',
            1: 'Middle Market',
            2: 'Strong Market',
          },
        },
        {
          column: 'start_date',
          default: 'N/A',
          type: 'DATE',
          label: 'Start Date',
        },
        {
          label: 'Impact on Residential Properties within 2,000 ft.',
          type: 'TITLE',
        },
        {
          column: 'res_properties_impacted',
          default: 'N/A',
          type: 'TEXT',
          label: 'Number of Residential Properties Impacted',
        },
        {
          column: 'opportunity_impact_res',
          default: 'N/A',
          type: 'DOLLARS',
          label: 'Impact on Restidential Properties',
        },
        {
          column: 'res_occ_impact',
          default: 'N/A',
          type: 'PERCENT_DECIMAL',
          label: 'Residential Occupancy Impact',
        },
        {
          label: 'Impact on Commercial Properties within 2,000 ft.',
          type: 'TITLE',
        },
        {
          column: 'com_properties_impacted',
          default: 'N/A',
          type: 'TEXT',
          label: 'Number of Commercial Properties Impacted',
        },
        {
          column: 'opportunity_impact_com',
          default: 'N/A',
          type: 'DOLLARS',
          label: 'Impact on Commercial Properties',
        },
        {
          column: 'com_occ_impact',
          default: 'N/A',
          type: 'PERCENT_DECIMAL',
          label: 'Commercial Occupancy Impact',
        },

        {
          label: 'Impact on All Properties within 2,000 ft.',
          type: 'TITLE',
        },
        {
          column: 'jobs',
          default: 'N/A',
          type: 'TEXT',
          label: 'Jobs Created',
        },
        {
          column: 'total_impact',
          default: 'N/A',
          type: 'DOLLARS',
          label: 'Total Impact',
        },
        {
          label: 'More Detail',
          type: 'TITLE',
        },
        {
          column: 'opp_highlights',
          default: 'N/A',
          type: 'TEXT',
          label: 'Deal Description',
        },
      ],
    },
  ],
};
